export type LoadErrorType = 'TIMEOUT' | 'LOAD';

export class LoadError extends Error {
  type: LoadErrorType;

  constructor(msg: string | Error, type?: LoadErrorType) {
    super(msg instanceof Error ? msg.message : msg);

    this.type = msg instanceof LoadError ? msg.type : type ?? 'LOAD';
  }
}
